// extracted by mini-css-extract-plugin
export var bi_cookies = "cookies-module--bi_cookies--0029d";
export var bi_cookies_panel = "cookies-module--bi_cookies_panel--91507";